import { getQueryClient } from "@/services/get-query-client";
import { authenticatedFetch } from "@/services/utils/authenticatedFetch";

type DeleteBlobResponse = {
  status: "OK" | "ERROR";
  response?: {
    message: string;
  };
  errors?: Array<{
    message: string;
  }>;
}

export default async function deleteBlob(blobName: string): Promise<DeleteBlobResponse> {
  const queryClient = getQueryClient();
  
  const url = "/api/blob/delete";

  const response = await authenticatedFetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      blob_name: blobName,
    }),
  });

  if (!response.ok) {
    throw new Error(`Failed to delete blob: ${response.status}`);
  }

  const result = await response.json() as DeleteBlobResponse;
  
  // Invalidate and refetch the blobs list after successful deletion
  if (result.status === "OK") {
    console.log("Delete successful, invalidating blobs cache...");
    await queryClient.invalidateQueries({ queryKey: ["blobs"] });
    console.log("Blobs cache invalidated");
  }
  
  return result;
}
